var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide",class:{'active': _vm.slideNumber - 1 === _vm.carousel.getCurrent()},style:('transform: translate3d(' +
     _vm.position(_vm.slideNumber - 1) * 100 + '%, 0, 0)')},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }